//  StockTransfers.aspx
var StockTransfers = (function(backOffice, $) {

    backOffice.Inventory.StockTransfers = (function() {
        var scopeSelector = backOffice.options.scopeSelector;

        var initialise = function(options) {
            $.extend(backOffice.options, options);
            events();
        };

        var events = function() {

            $("tr[data-productId] td input").change(function updateSingle() {
                let transferStage = $("#ddlProcess", scopeSelector).val(),
                    selectedTransferStage = backOffice.options.TransferStages.filter((stage) => {
                        return stage.Value == transferStage;
                    });

                updateTransferStageColumnTotals(selectedTransferStage[0].Name);
            });
        };

        var updateTransferStageColumnTotals = function(transferStage) {
            let footerElement = $(".footer-" + transferStage, scopeSelector),
                grandTotalPrice = 0,
                grandTotalQty = 0;

            $("td.transferAction-" + transferStage).each(function iterateDataRows(e) {
                let rowQty = parseInt($(this).find("input").val()),
                    rowPrice = parseFloat($(this).closest("tr").attr("data-buyex")).toFixed(2);

                grandTotalQty += parseInt($(this).find("input").val());
                grandTotalPrice += rowQty * rowPrice;
            });

            footerElement.html(grandTotalQty + "<br/>$" + grandTotalPrice.toFixed(2));
            return true;
        };

        var incrementQuantityByTransferStage = function(productId) {
            let transferStage = $("#ddlProcess", scopeSelector).val(),
                selectedTransferStage = backOffice.options.TransferStages.filter((stage) => {
                    return stage.Value == transferStage;
                });

            //  is there a matching transfer stage value and was a productId passed in?
            if (selectedTransferStage.length != 1 || !productId) {
                return false;
            }

            //  create an array and get the matching row selectors
            let matchingRows = [],
                foundRows = document.querySelectorAll("tr[data-productid='" + productId + "'], tr[data-sku='" + productId + "']", scopeSelector) || [];

            var foundBarcodeRows = document.querySelectorAll("tr[data-barcodes*='" + productId + "']", scopeSelector);
            for (var i = 0; i < foundBarcodeRows.length; i++) {
                var row = foundBarcodeRows[i];
                if (row.getAttribute('data-barcodes').split(' ').indexOf(productId) >= 0) {
                    var rowAlreadyAdded = false;
                    for (let i = 0; i < foundRows.length; i++) {
                        if (foundRows[i] == row) {
                            rowAlreadyAdded = true;
                        }
                    }
                    if (!rowAlreadyAdded) {
                        matchingRows.push(row);
                    }
                }
            }

            //  populate the array with the selectors so we can iterate
            //  we have to use the prototype because a dom nodelist is not a true js array
            [].forEach.call(foundRows, function(el) {
                    matchingRows.push(el);
                });

            if (matchingRows.length === 0){
                return false;
            }

            let el = $(matchingRows[0].querySelector("input")),
                totalScanned = el.val(),
                totalAvailable = el.closest("td").data("totalavailable");

            //  were there any available from the previous transfer status?
            if (totalAvailable > 0) {
                if (totalScanned == totalAvailable && matchingRows.length > 1) {
                    //  remove the first item from the array so we can move on to the next matching row
                    matchingRows.splice(0,1);
                    //  get the input element for the new matching row
                    el = $(matchingRows[0].querySelector("input"));
                }
            }

            //  are there issues with the data?
            if (isNaN(parseInt(el.val()) || !el || !el.val())) {
                return false;
            }

            //  go thunderbirds
            el.val(parseInt(el.val()) + 1);
            updateTransferStageColumnTotals(selectedTransferStage[0].Name);
            return false;   //  return false to stop form processing (even though there is already a return false in the markup :/)
        };

        var scheduleButton = function (toggle, idx) {
            if (toggle){
                if (idx == 3) {
                    $("#btnSchedule", scopeSelector).hide();
                }
                else{
                    $("#btnSchedule", scopeSelector).show();
                }
            }
        };

        var printTransferDetails = function (transferId, sortExpr, sortDirection){
            var winPrint = window.open('TransferSlipPDF.aspx?TransferID=' + transferId + '&sortExpr=' + sortExpr + '&sortDirection=' + sortDirection, null, 'height=450,width=800,resizable=yes,scrollbars=yes,location=no,menubar=yes,status=no');

            winPrint.onload = function (){
                var css = '@page { size: landscape; } }',
                    head = winPrint.document.head || winPrint.document.getElementsByTagName('head')[0],
                    style = winPrint.document.createElement('style');

                style.type = 'text/css';
                style.media = 'print';

                if (style.styleSheet){
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(winPrint.document.createTextNode(css));
                }

                head.appendChild(style);

                winPrint.focus();
                winPrint.print();
            };

            return false;
        };

		return $.extend(backOffice.Inventory.StockTransfers, {
            Init: initialise,
            ScheduleButtonWorker: scheduleButton,
            IncrementQuantityByTransferStage: incrementQuantityByTransferStage,
            PrintTransferDetails: printTransferDetails
		});
	})();

	return backOffice.Inventory.StockTransfers;
})(BackOffice || {}, jQuery);
